import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sorriso from "./pages/Sorriso";
import MenuChoice from "./pages/MenuChoice";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Sorriso />} />
          <Route path="/meniu" element={<MenuChoice />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
